import { MuiThemeProvider } from 'material-ui/styles'
import React from 'react'
import theme from '../common/theme'
import WebChatIndex from './WebChatIndex'

function WebChatApp() {
  return (
    <MuiThemeProvider theme={theme}>
      <WebChatIndex />
    </MuiThemeProvider>
  )
}
export default WebChatApp

export function WebChatAppNonModal() {
  return (
    <MuiThemeProvider theme={theme}>
      <WebChatIndex nonModal={true} />
    </MuiThemeProvider>
  )
}
